import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { NgxsStateFacade } from './ngxs-state-facade';

export class SetTitle {
  static readonly type = '[Title] Set';
  constructor(public title: string) {}
}

@State<string>({
  name: 'title',
  defaults: '',
})
@Injectable()
export class TitleState extends NgxsStateFacade<string> {
  @Selector()
  static title(state: string): string {
    return state;
  }

  get title(): string {
    return this.snapshot;
  }

  constructor(
    private readonly platformTitle: Title,
    private readonly translate: TranslateService,
    store: Store,
  ) {
    super(store, 'title');
  }

  setTitle(title: string): void {
    this.store.dispatch(new SetTitle(title));
  }

  @Action(SetTitle)
  setTitleHandler(ctx: StateContext<string>, action: SetTitle): void {
    const translated = this.translate.instant(action.title);
    this.platformTitle.setTitle(`${translated} | Qreddi`);
    ctx.setState(translated);
  }
}
